export const social = {
	label: {
		shareLink: 'Share Link',
		generateDxf: 'Generate DXF',
		generatePresentation: 'Generate Presentation'
	},
	tooltip: {
		noEmail: 'Customer email is required to share link',
		noDesign: 'Design Selection is required to share link',
		shareLink: 'Copy a shareable view-only link to the clipboard',
		snapshot: 'Take a Snapshot',
		generateDxf: 'Generate DXF file',
		noGenerateDxf: 'Design Selection is required to generate DXF file',
		generatePresentation: 'Generate a customer presentation with 3D renders',
		noGeneratePresentation: 'A customer with saved designs is required to generate a presentation',
		designPackagesComingSoon: 'Design Packages Coming Soon'
	},
	message: {
		copiedToClipboard: 'Link copied to clipboard!',
		downloadSnapshot: 'Snapshot download started!',
		generateDxf: 'DXF file generation started!',
		presentationLinkCopied: 'Presentation link copied to clipboard!',
		deletePackageWarning: 'Every share link for this package 404s immediately, and it disappears from the customer\'s lists now. The underlying files are purged by a later nightly sweep, so it is recoverable for a short window — not deleted forever on the spot.',
		packageDeleted: 'Design package deleted.',
		deletePackageFailed: 'Could not delete the design package. Please try again.'
	}
};
